import { imageUrlValidatorParam, validatorImageList, clean } from '@/components/Uploader/helper'
import { ERROR_TYPE } from '@/components/Uploader/constants'

import uniqBy from 'lodash/uniqBy'
import omit from 'lodash/omit'
import repairUrlData from './repairUrlData'

export const transImagesErrors = ({ value, singleValidate }) => {
    const validatorParam = imageUrlValidatorParam(singleValidate)
    const cleanList = Array.isArray(value) ? clean(value) || [] : [value]

    const { errorList } = validatorImageList({
        cleanList,
        value,
        validatorParam: omit(validatorParam, ['validatorNum'])
    })

    return errorList
}

export const transReplaceErrors = imagesErrors => {
    return imagesErrors.filter(item => item.type === ERROR_TYPE.RECT || item.type === ERROR_TYPE.RATIO)
}

export const transReplaceImages = ({ singleValidate, name, replaceErrors }) => {
    const validatorParam = imageUrlValidatorParam(singleValidate)
    const mergeErrors = uniqBy(replaceErrors, 'url')

    return mergeErrors.map(item => {
        return {
            ...repairUrlData({
                url: item.url,
                validatorParam
            }),
            name
        }
    })
}

export const replacePicToGoodsSku = ({ value: goodsSku, newPics }) => {
    return goodsSku.map(item => {
        return {
            ...item,
            value: item?.value?.map(item2 => {
                if (item2?.pic && typeof item2?.pic === 'object') {
                    const newPic = newPics?.find(item3 => item3?.oldUrl === item2?.pic?.url)

                    return {
                        ...item2,
                        pic: {
                            ...item2?.pic,
                            url: newPic?.newUrl || item2?.pic?.url
                        }
                    }
                }
                return item2
            })
        }
    })
}

export const replacePicToValue = ({ value, newPics }) => {
    try {
        if (!Array.isArray(newPics)) {
            return null
        }

        if (Array.isArray(value)) {
            return value.map(item => {
                const replaceItem = newPics.find(item2 => item2?.oldUrl === item?.url)

                if (replaceItem) {
                    return {
                        ...item,
                        url: replaceItem?.newUrl
                    }
                }

                return item
            })
        } else if (typeof value === 'object') {
            const replaceItem = newPics.find(item2 => item2?.oldUrl === value?.url)
            return {
                ...value,
                url: replaceItem?.newUrl
            }
        }

        return null
    } catch (error) {
        console.error('replacePicToValue', error)
        return null
    }
}
